import { ca } from '@cian/analytics';

export function trackDemandTrapShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show',
    label: 'Banner',
    banner_location: 'Chats',
  });
}

export function trackDemandTrapSend() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'Page',
    banner_location: 'Chats',
  });
}
